module.exports = __webpack_public_path__ + "img/persona_oculus.052f8805.png";